import { render, staticRenderFns } from "./PreviewPicture.vue?vue&type=template&id=18d2fb67&scoped=true&"
import script from "./PreviewPicture.vue?vue&type=script&lang=js&"
export * from "./PreviewPicture.vue?vue&type=script&lang=js&"
import style0 from "./PreviewPicture.vue?vue&type=style&index=0&id=18d2fb67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d2fb67",
  null
  
)

export default component.exports